import moment from "moment"
import { isCRSOtherSels } from '../../../Football/Common/CRSTable';
import { getNumberSuffix } from '../../../Football/Common/MatchBase';

export const getXtremePushData = (betLineData, apiData,t) =>{
    let tr = (key) =>{
        return t(key,{lng:'en'})
     }
    if(!betLineData || !apiData)return
    if(!apiData?.oddsFlag || apiData?.oddsFlag == '0'){
        let betObj = betLineData.betObj
        let creation_datetime  = moment().utcOffset('+08:00').toISOString()
        let bet_type = ``
        let details = ''
        let event_name_chi = ''
        let event_name_eng  = ''
        let frontend_id  = ''
        let allup = 0
        let matchStage = ''
        if(betLineData.prod === 'FB'){
            let inplay = betObj.inplayDelay ? 1 : 0
            let matchid
            bet_type = tr(`LB_FB_TITLE_${betObj.betType}`)
            let isAllUp = betObj.betType.includes('ALUP')
            if(isAllUp){
                allup = 1
                bet_type = `${allupLabelFn(betObj, tr)} ${betObj?.selectedFormula || ''}`
                details = getFBAllUpDetail(betLineData,tr)
                betObj.betList.forEach((item,index) =>{
                    if(index ==0){
                        frontend_id = item.frontEndId
                        matchStage = parseMatchStage(item?.matchInfo?.status)
                        if(isTournPool(item.betType)){
                            event_name_chi = item.tournamentNameCH
                            event_name_eng = item.tournamentNameEN
                        }else{
                            matchid = `${item.matchId}`
                            event_name_chi = item.matchTeamCH
                            event_name_eng = item.matchTeamEN
                        }
                    }else{
                        matchid += `::${item.matchId}`
                        frontend_id += `::${item.frontEndId}` 
                        event_name_chi += `::${item.matchTeamCH}`
                        event_name_eng += `::${item.matchTeamEN}`
                        matchStage += `::${parseMatchStage(item?.matchInfo?.status)}`
                    }

                })
            }else{
                details = getFBSingleDetail(betLineData,tr)
                frontend_id = betObj.frontEndId
                if(isTournPool(betObj.betType)){
                    matchid = betObj?.matchInfo?.id
                    event_name_chi = betObj.tournamentNameCH
                    event_name_eng = betObj.tournamentNameEN
                    matchStage = parseMatchStage(betObj?.matchInfo?.status)
                }else{
                    matchid = betObj.matchId
                    event_name_chi = betObj.matchTeamCH
                    event_name_eng = betObj.matchTeamEN
                    matchStage = parseMatchStage(betObj?.matchInfo?.status)
                }
            }
            return {
                sport: 'Football',
                product: "Sport",
                bet_id: apiData.txNo,
                guid: sessionStorage.getItem('customerHash'),
                bet_type,
                creation_datetime,
                details,
                event_name_chi: event_name_chi || "",
                event_name_eng: event_name_eng || "",
                frontend_id: frontend_id || "",
                allup,
                inplay,
                "match stage": matchStage,
                matchid: matchid || ""
            }
        }else if(betLineData.prod === 'HR'){
            let race_no = ''
            let race_meeting_id = betObj.meetingId
            bet_type = tr(`LB_${betObj.betType}`)
            let isAllUp = ["CROSS_ALUP", "CWAALUP", "WPALUP", "WPQALUP" , "FCTALUP", "TRIALUP"].includes(betObj.betType)
            let isMultPool = window.racingConfig.multiRacePool.split(';').includes(betObj.betType)
            let isSinglePool = [...window.racingConfig.singleRacePool.split(';'),"W-P","WP","QQP", 'JKC','TNC'].includes(betObj.betType)
            let curMeeting = betObj.meeting
            if(isSinglePool){
                let curRace = curMeeting?.races?.find(race => race.no == betObj.raceno) || {}
                race_no = betObj.raceno
                event_name_chi = curRace?.raceName_ch
                event_name_eng = curRace?.raceName_en
                details = getRCSingleRaceDetail(betObj,tr)
            }else{
                let betList = betObj?.betList ||[]
                if(isAllUp){
                    allup = 1
                    let betTypes = []
                    betList.forEach((item,index) => {
                        betTypes.push(item.betType)
                    });
                    if([...new Set(betTypes)].length >1){
                        bet_type = `All Up Cross Pool ${betLineData.betObj.allupFormula}`
                    }else{
                        bet_type = `All Up ${betTypes[0]} ${betLineData.betObj.allupFormula}`
                    }
                }
                betList.forEach((betItem,index) => {
                    
                    let curRace = curMeeting?.races?.find(race => race.no == betItem.raceNo) || {}
                     if(index > 0){
                        race_no += `::${betItem.raceNo}`
                        event_name_chi += `::${curRace.raceName_ch}`
                        event_name_eng += `::${curRace.raceName_en}`
                     }else{
                        race_no += `${betItem.raceNo}`
                        event_name_chi = curRace.raceName_ch
                        event_name_eng = curRace.raceName_en

                     }
                });
                details = getRcMultRaceDetail(betObj,tr)
            }
            
            return {
                sport: 'Racing',
                product: "Sport",
                bet_id: apiData.txNo,
                guid: sessionStorage.getItem('customerHash'),
                bet_type,
                creation_datetime,
                details,
                event_name_chi: event_name_chi || "",
                event_name_eng: event_name_chi || "",
                race_no: race_no || "",
                race_meeting_id,
                allup
            }
        }
        return null
    }

    return null

}

const getRCSingleRaceDetail = (betObj, t) =>{
    let venue = t(`LB_${betObj.venueid}`)
    let dateOfWeek = betObj.dayid
    let betType = t(`LB_${betObj.betType}`)
    let raceNo = raceNo ? ` Race ${betObj.raceno}` : ""
    let subType = betObj.subType ?  t(`LB_STYPE_${betObj.subType}`) : ''
    let unitBet = betObj.unitBet
    let combination = getRacingCombs(betObj.bankers, betObj.combs, betObj.betType, t)
    let isFlexi = betObj.isFlexi
    let betTotal = betObj.betTotal
    let amount = isFlexi? `$$${betTotal}` : `$${unitBet}`
    let quickPick =  betObj.isRandom ? `(${t('LB_BS_RANDOMNO')}) ` : ''
    let details = `${venue} ${dateOfWeek} ${betType}${subType ? ` ${subType}` : ''}${raceNo} ${combination} ${quickPick}${amount}`
    return details
}

const getRcMultRaceDetail = (betObj, t)=>{
    let betList = betObj.betList
    let venue = t(`LB_${betObj.venueid}`)
    let dateOfWeek = betObj.dayid
    let betType = t(`LB_${betObj.betType}`)
    // let raceNo = `Race ${betObj.raceno}`
    let unitBet = betObj.unitBet
    let isFlexi = betObj.isFlexi
    let betTotal = betObj.betTotal
    let amount = isFlexi ? `$$${betTotal}` : `$${unitBet}`
    let quickPick =  betObj.isRandom ? `(${t('LB_BS_RANDOMNO')}) ` : ''
    let combination = ''
    let isAllUp = ["CROSS_ALUP", "CWAALUP", "WPALUP", "WPQALUP" , "FCTALUP", "TRIALUP"].includes(betObj.betType)
    if(isAllUp){
        let betTypes = []
        betList.forEach((item,index) => {
            betTypes.push(item.betType)
            let betType = t(`LB_${item.betType}`)
            let subType = item.subType ?  t(`LB_STYPE_${item.subType}`) : ''
            let raceNo = `Race ${item.raceNo}`
            let curSels = getRacingCombs(item.bankers, item.combs, item.betType, t)
            combination += ` ${raceNo} ${betType}${subType? ` ${subType}` : ''} ${curSels}`
        });
        if([...new Set(betTypes)].length >1){
            betType = `All Up Cross Pool ${betObj.allupFormula}`
        }else{
            betType = `All Up ${betTypes[0]} ${betObj.allupFormula}`
        }
        return `${venue} ${dateOfWeek} ${betType}${combination} $${unitBet}`
    }else{
        betList.forEach((item,index) => {
             let raceNo = `Race ${item.raceNo}`
            let curSels = getRacingCombs(item.bankers, item.combs, item.betType, t)
            combination += ` ${raceNo} ${curSels}`
        })

        return `${venue} ${dateOfWeek} ${betType}${combination}  ${quickPick}${amount}`
    }
    

}

const getRacingCombs = (bankers, combs, betType, t) =>{
    let combination = ''
    let bankerText = t('LB_BS_BANKER_WITH')
    bankers?.map((subBankers) => {
        if (subBankers.length > 0) {
            subBankers?.map((runner, index) => {
                combination+=` ${runner.no} ${runner.name_en } ${index === subBankers.length - 1 ? '' : ' + '}`
            })
            combination += ` ${bankerText}`
        }
    })
        combs.map((runner, index) => {
        if (!runner) return;
        const connector = betType == 'IWN' ? ' # ' : ' + ';
        combination += ` ${runner.no || runner.number} ${runner.name_en} ${['JKC', 'TNC'].includes(betType) ? `@${runner.currentOdds}` : index === combs.length - 1 ? '' : connector}`
    })

    return combination
}

const getFBAllUpDetail = (betLineData,t) =>{

    const betObj = betLineData.betObj
    let betlineStr = betObj.betList.map((item) => {
        const itemBetName = t(`LB_FB_TITLE_${item.betType}`);
        let instNo = instNoName(item, item.betType,t)
        let teamName = item?.matchTeamEN
        let tournName = item?.tournamentNameEN
        let str = `${item.frontEndId} ${teamName ? teamName : tournName} ${itemBetName}${instNo ? ` ${instNo}`:''}`;
        // let combName = combinationName(item.combs[0])

    
        if(['GPW', 'GPF'].includes(item.betType)){

            str = `${item.frontEndId}`
            item.combs.forEach((i) => {
                const itemBetName = t(`LB_BS_${i.betType}_S`);
                str += ` ${itemBetName}${i.raceno} ${combinationName(i,t)}@${i.oddsVal}`;
            });
        }else{
            item.combs.forEach((i) => {
                let odds = i?.oddsVal
                str += ` ${combinationName(i,t)}@${odds}`

            });

        }
        return str;
    });
    return `${betlineStr} $${betLineData.unitBet}`
}
const getFBSingleDetail = (betLineData,t) =>{

    const betObj = betLineData?.betObj
    let isTourn = isTournPool(betObj.betType)
    let frontendId = betObj.frontEndId
    let betTypeName = t(`LB_FB_TITLE_${betObj.betType}`)
    let combName = combinationName(betObj.combs[0], t)
    let odds = betObj.combs[0]?.oddsVal
    let instNo = instNoName(betObj, betObj.betType, t)

    let teamName = betObj?.matchTeamEN
    let tournName = betObj?.tournamentNameEN
    
    return `${frontendId} ${teamName ?teamName : tournName} ${betTypeName}${instNo? ` ${instNo}`: ''} ${combName}@${odds} $${betLineData.unitBet}`
}

const isTournPool = (betType)=>{
    return ['CHP', 'TPS', 'TSP', 'TQL', 'FINALIST', 'WINCNTY', 'WINCNTT', 'GPW', 'GPF'].includes(betType)
}

const combinationName = (comb,t) => {
    
    let selectedComb = comb.id.split('_')[comb.id.split('_').length - 1];
    let condition = !comb.condition || comb.condition === '0.0' ? '' : `[${comb.condition}]`;
    if (['HIL', 'FHL', 'CHL', 'EHL', 'ECH', 'FCH',...window.fbConfig.TeamGoalLinePools].includes(comb.betType)) {
        selectedComb = selectedComb === 'H' ? 'HIGH' : 'LOW';
        condition = !comb.condition || comb.condition === '0.0' ? '' : comb.lineNum ? `[${comb.lineNum}]` : `[${comb.condition}]`;
    }
    let combName = t(`LB_BS_ADDTOSLIP_FB_${selectedComb}`);
    if (['TTG', 'ETG'].includes(comb.betType)) {
        combName = selectedComb;
    }
    if (['CRS', 'FCS', 'ECS'].includes(comb.betType)) {
        combName = isCRSOtherSels(selectedComb)
            ? t(`LB_BS_ADDTOSLIP_FB_${selectedComb}`)
            : selectedComb
                    .split(':')
                    .map((i) => parseInt(i))
                    .join(':');
    }
    if (['HFT'].includes(comb.betType)) {
        combName = selectedComb
            .split(':')
            .map((i) => t(`LB_BS_ADDTOSLIP_FB_${i}_S`))
            .join('-');
    }
    if (['FTS'].includes(comb.betType)) {
        combName = selectedComb
            .split(':')
            .map((i) => t(`LB_BS_ADDTOSLIP_FB_${i}_M`))
            .join('-');
    }
    if (['MSP', 'TSP', ...window.fbConfig.GSPools, 'SGA'].includes(comb.betType)) {
        const nameObj = comb.currentCombNameObj || {};
        selectedComb = selectedComb === '000' ? '00' : selectedComb;
        combName = `${[...window.fbConfig.GSPools, 'SGA'].includes(comb.betType) ? `${selectedComb} ` : `(${selectedComb})`}${
            nameObj['name_en']
        }`;
    }
    if (['CHP', 'TPS', 'TQL', 'FINALIST', 'WINCNTY', 'WINCNTT'].includes(comb.betType)) {
        const selectedCombNumber = comb.currentCombNameObj?.str;
        combName = `${selectedCombNumber} ${comb?.currentCombNameObj?.['name_en']}`;
    }
    if (['GPW', 'GPF'].includes(comb.betType)) {
        combName = `${comb?.currentPool?.['name_en']} ${comb?.currentCombNameObj?.['name_en']}`
    }
    return `${combName}${condition}`
};

const instNoName = (betObj, betType,t) => {
    
    const instNo = betObj?.instNo;
    let ngoal = `${instNo}${getNumberSuffix(instNo)}`;
    switch (betType) {
        case 'TQL':
        case 'GPF':
        case 'GPW':
            return betObj?.combs?.[0]?.currentPool?.instNo;
        case 'NGS':
        case 'NTS':
        case 'ENT':
            return `[${t('LB_FB_N_GOAL').replace('{0}', ngoal)}]`;
        default:
            return '';
    }
};

const allupLabelFn = (betObj, t) => {
    let betList = betObj.betList;
    if (window.fbConfig.TournamentAllupPools.includes(betList[0].betType)) {
        betList = betList[0].combs;
    }
    const firstBetType = betList[0].betType;
    const isCrossPoolAllup = betList.find((item) => {
        return item.betType !== firstBetType;
    });
    const text = isCrossPoolAllup
            ? 'LB_BS_BET_CROSSALLUP'
            : 'LB_ALLUP'
    return t(text);
};

// const parseMatchStage = (status) =>{
//     switch (status) {
//         case 'FIRSTHALF':
//             return 'FirstHalf'
//         case 'SECONDHALF':
//             return 'SecondHalf'
//         case 'FIRSTHALFCOMPLETED':
//         case 'FULLTIMECOMPLETED':
//         case 'MATCHENDED':
//         case 'INPLAYMATCHENDED':
//         case 'MATCHSUSPENDED':
//         case 'EXTRATIME':
//         case 'FIRSTHALFET':
//         case 'FIRSTHALFETCOMPLETED':
//         case 'SECONDHALFET':
//         case 'SECONDHALFETCOMPLETED':
//         case 'PENALTYKICK':
//         case 'PENALTYKICKCOMPLETED':
//         default:
//             return status
//     }
// }

const parseMatchStage = (status) => {
    switch (status) {
        case 'PREEVENT':
            return 'PreEvent'
        case 'FIRSTHALF':
            return 'FirstHalf'
        case 'SECONDHALF':
            return 'SecondHalf'
        case 'FIRSTHALFCOMPLETED':
            return 'FirstHalfCompleted'
        case 'FULLTIMECOMPLETED':
            return 'FullTimeCompleted'
        case 'MATCHENDED':
            return 'MatchEnded'
        case 'INPLAYMATCHENDED':
            return 'InPlayMatchEnded'
        case 'MATCHSUSPENDED':
            return 'MatchSuspended'
        case 'EXTRATIME':
            return 'ExtraTime'
        case 'FIRSTHALFET':
            return 'FirstHalfET'
        case 'FIRSTHALFETCOMPLETED':
            return 'FirstHalfETCompleted'
        case 'SECONDHALFET':
            return 'SecondHalfET'
        case 'SECONDHALFETCOMPLETED':
            return 'SecondHalfETCompleted'
        case 'PENALTYKICK':
            return 'PenaltyKick'
        case 'PENALTYKICKCOMPLETED':
            return 'PenaltyKickCompleted'
        default:
            return ''
    }
}